import React, { useEffect, useState } from 'react';

const getOnlineStatus = () => (
    typeof navigator === 'undefined' ? true : navigator.onLine
);

const NetworkStatus = () => {
    const [isOnline, setIsOnline] = useState(getOnlineStatus);

    useEffect(() => {
        const handleOnline = () => setIsOnline(true);
        const handleOffline = () => setIsOnline(false);
        window.addEventListener('online', handleOnline);
        window.addEventListener('offline', handleOffline);
        return () => {
            window.removeEventListener('online', handleOnline);
            window.removeEventListener('offline', handleOffline);
        };
    }, []);

    if (isOnline) return null;

    return (
        <div
            role="status"
            aria-live="polite"
            style={{
                position: 'sticky',
                top: 0,
                zIndex: 2000,
                padding: '0.55rem 1rem',
                textAlign: 'center',
                color: '#fff',
                background: '#7a2e00',
                fontSize: '0.9rem',
            }}
        >
            You&apos;re offline. Saved data is available; changes require a connection.
        </div>
    );
};

export default NetworkStatus;

